import { useQuery } from "@tanstack/react-query";
import { apiInstance } from "@repo/core/services/instances/api";
import { CommonResource } from "@repo/core/services/resources/common";
import {
  getLayoutBandeirasQueryKey,
  normalizeLayoutBandeirasProductParam,
  shouldConsultLayoutBandeiras
} from "@repo/core/utils/layoutBandeiras.utils";

const commonResource = new CommonResource(apiInstance);

export const useLayoutBandeiras = (
  strProduto?: string | null,
  enabled = true
) => {
  const productParam = normalizeLayoutBandeirasProductParam(strProduto);
  const shouldFetch = shouldConsultLayoutBandeiras(productParam, enabled);

  return useQuery({
    queryKey: getLayoutBandeirasQueryKey(productParam),
    queryFn: ({ queryKey }) => {
      const productFromQueryKey =
        typeof queryKey[1] === "string" ? queryKey[1] : productParam;
      return commonResource.fetchFlags(productFromQueryKey);
    },
    select: (response) => response.data,
    enabled: shouldFetch
  });
};
